export default "__VITE_ASSET__Tika5NqA__"